import React from "react";
import { Link } from "react-router-dom";

const TECH_STACK = [
  "AWS Lambda & Bedrock",
  "Amazon Polly TTS",
  "React & Tailwind",
  "GitHub Actions",
];

const Footer = () => {
  return (
    <footer className="mt-auto bg-ink-900 text-slate-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
                </svg>
              </div>
              <span className="text-base font-bold text-white">AWS Daily Updates</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-md">
              AWS announcements transformed into professional audio briefings
              using AI — fully automated, updated every day.
            </p>
            <div className="flex items-center gap-2 mt-5">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-50" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
              </span>
              <span className="text-xs text-slate-400 font-medium">Live &amp; fully automated</span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">
              Navigation
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-slate-400 hover:text-white transition-colors duration-200">
                  Episodes
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-slate-400 hover:text-white transition-colors duration-200">
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Powered by */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">
              Powered By
            </h4>
            <ul className="space-y-2.5">
              {TECH_STACK.map((tech) => (
                <li key={tech} className="text-sm text-slate-400">
                  {tech}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-slate-500 text-xs">
            © 2026 AWS Daily Updates · Educational Project
          </p>
          <p className="text-slate-500 text-xs">Built with ❤️ for learning</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
